<template>
  <div
    class="h-100 mb-4 border-0 js-form-wrapper form-group position-relative step-subcategory "
    :data-review="review"
    :class="list.invalid ? 'questionlist invalid' : ''"
    id="edit-border">
    <!--    {{list}}-->
    <div v-if="!review" class="content">
      <fieldset
        :data-collapse="collapsed"
        :id="stepind+'-'+safeName(list.title)"
        class="form-no-label form-group">
        <h3>{{list['title']}}</h3>
      </fieldset>
      <div class="questions">
        <template v-for="(question,i) in list.question">
          <question :ref="'question-'+i" :stepind="stepind" :review="review" :question="question"></question>
        </template>
      </div>
    </div>
    <!--    <div class="comment-container position-relative">-->
    <!--      <button v-show="!showComment" @click.prevent="showComment = !showComment" class="btn comment-toggle show">-->
    <!--        <template v-if="comment">-->
    <!--          <i class=" far fa-clipboard"></i>-->
    <!--        </template>-->
    <!--        <template v-else>-->
    <!--          <i class=" fas fa-plus"></i>-->
    <!--        </template>-->
    <!--      </button>-->
    <!--      <button v-show="showComment" @click.prevent="showComment = !showComment" class="btn comment-toggle hide">-->
    <!--        <i class=" fas fa-times"></i>-->
    <!--      </button>-->

    <!--    </div>-->
    <!--    submiss id: {{submission_id}}-->
    <template v-if="review">
      <!--      {{vitaminFormData.submitted}}-->
      <!--  todo strapi moet information doorgeven    -->
      {{list['information']}}
    </template>

    <textarea
      :placeholder="!review || (review && this.vitaminFormData.submitted.status !== 'reviewed') ? $t('message.comment_placeholder',{subcategory:list['title']}) : ''"
      class="styled-input form-control category-comment"
      :class="(this.vitaminFormData.submitted ? (this.vitaminFormData.submitted.status === 'reviewed' ? 'disabled h-100' : ' h-100') : '')"
      :disabled="review ? (this.vitaminFormData.submitted ? (this.vitaminFormData.submitted.status === 'reviewed') : false) : false"
      v-model="comment"
      :data-comment-id="comment.id"
      :name="'comment-'+list.id"
      :id="'comment-'+list.id"
      cols="30"
      rows="5"></textarea>
  </div>
</template>

<script>
  import Question from "./Question";
  import store from "../../store/store";

  export default {
    watch: {
      submission_id() {
        this.getComment()
      },
      comment() {
        // console.log('changing this list')
        this.list.comment = this.comment;
      }
    },
    data() {
      return {
        showComment: false,
        comment: ''
      }
    },
    computed: {
      submission_id() {
        if (this.review) {
          return this.$route.params.id
          // return this.previousId
        } else if (this.draft) {
          return this.draftId
        } else {
          return null
        }
      },
      draft() {
        return this.$route.query.draft
      },
      draftId() {
        return this.vitaminFormData.draft.id
      },
      previousId() {
        return this.vitaminFormData.previous[0].id
      },
      vitaminFormData() {
        return store.getters.getVitaminFormData
      },
      collapseResult() {
        return this.review ? this.collapsed : false
      }
    },
    mounted() {
      this.getComment();
    },
    methods: {
      getComment() {
        if (this.submission_id) {
          let filters = '';
          filters += `?subcategoryid=${this.list.id}`;
          filters += `&userid=${store.getters.getUserId}`;
          filters += `&submissionid=${this.submission_id}`;
          this.axios.get(`/comments${filters}`).then(r => {
            if (r.data.length) {
              this.comment = r.data[0].text
            }
          })
        }
      },
      toggleCollapse() {
        this.collapsed = !this.collapsed
      }
    },
    props: {
      stepind: {
        type: Number,
        default() {
          return 0
        }
      },
      collapsed: {
        type: Boolean,
        default() {
          return true;
        }
      },
      list: Object,
      review: {
        Boolean,
        default() {
          return false
        }
      }
    },
    components: {
      Question
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Vitamins/QuestionList.vue